/**
 * TypewriterText — small presentational component that types out a
 * string character-by-character. Used when new chat names arrive so the
 * sidebar hints at the new entry without a flash.
 */

import { useEffect, useRef, useState } from 'react';

type Props = {
    text: string;
    speed?: number;
    onDone?: () => void;
};

export default function TypewriterText({ text, speed = 30, onDone }: Props) {
    const [displayed, setDisplayed] = useState('');
    const onDoneRef = useRef(onDone);
    onDoneRef.current = onDone;

    useEffect(() => {
        let i = 0;
        setDisplayed('');
        const interval = setInterval(() => {
            i++;
            setDisplayed(text.slice(0, i));
            if (i >= text.length) {
                clearInterval(interval);
                onDoneRef.current?.();
            }
        }, speed);
        return () => clearInterval(interval);
    }, [text, speed]);

    return (
        <span className="chat-name typewriter">
            {displayed}
            <span className="typewriter-cursor">|</span>
        </span>
    );
}
